import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SnapperInstance } from './snapper';

gsap.registerPlugin(ScrollTrigger);
export function NineScene() {

    var content = document.querySelector('.nine-section');
    SnapperInstance.attachLocker(content);

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.eight-section',
            start: 'top top',
            end: '100%',
            scrub: 1,
            invalidateOnRefresh: true
        }
    });
    tl.set('.eight-section', { pointerEvents: 'none' });
    tl.to('.eight-section__text-block', 1, { y: '-=80vh' }, '+=2');
    tl.to('.eight-section, .first-bg, .second-bg, .third-bg, .overlay', 1, { opacity: 0 }, '-=0.1');
    tl.to('.nine-section__bg', 1, { opacity: 1 }, '-=1');
    tl.fromTo('.nine-section__text-block', 1, { y: '+=80vh', autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
    if (content.getElementsByTagName('h2').length) {
        tl.fromTo('.nine-section h2', 1, { y: '+=10vh', autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.3');
    }
    if (content.getElementsByTagName('p').length) {
        tl.fromTo('.nine-section p', 1, { y: '+=10vh', autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.6');
    }
    tl.fromTo('.nine-section__img-block', 1, { y: '+=10vh', autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.6');
}